import { Routes } from '@angular/router';
import { HUB_TEST_CONFIG } from './modules/pruebas-hub/config/hub-test.config';
import { PlaceholderPageComponent } from './shared/components/placeholder-page/placeholder-page.component';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./modules/dashboard/routes/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
  },
  {
    path: 'seguimiento',
    loadChildren: () =>
      import('./modules/seguimiento/routes/seguimiento.routes').then((m) => m.SEGUIMIENTO_ROUTES),
  },
  {
    path: 'elegibles',
    loadChildren: () =>
      import('./modules/elegibles/routes/elegibles.routes').then((m) => m.ELEGIBLES_ROUTES),
  },
  {
    path: 'conciliacion',
    loadChildren: () =>
      import('./modules/conciliacion/routes/conciliacion.routes').then((m) => m.CONCILIACION_ROUTES),
  },
  {
    path: 'parametrizacion',
    loadChildren: () =>
      import('./modules/parametrizacion/routes/parametrizacion.routes').then(
        (m) => m.PARAMETRIZACION_ROUTES,
      ),
  },
  // Solo dev: en producción HUB_TEST_CONFIG.habilitado es false (ver hub-test.config.prod.ts).
  ...(HUB_TEST_CONFIG.habilitado
    ? [
        {
          path: 'pruebas-hub',
          loadChildren: () =>
            import('./modules/pruebas-hub/routes/pruebas-hub.routes').then((m) => m.PRUEBAS_HUB_ROUTES),
        },
      ]
    : []),
  // Módulos de observación aún no implementados (placeholders).
  { path: 'contabilidad', component: PlaceholderPageComponent, data: { titulo: 'Conciliación contable', icon: 'accounting' } },
  { path: 'auditoria', component: PlaceholderPageComponent, data: { titulo: 'Auditoría', icon: 'audit' } },
  { path: 'ops', component: PlaceholderPageComponent, data: { titulo: 'Operación TIC', icon: 'ops' } },
  { path: '**', redirectTo: 'dashboard' },
];
